import React from 'react';

import { RangeFilter } from 'components/Filter';

import { FilterProps } from './index';

type Props = {
  value: [nil | string | number, nil | string | number];
} & FilterProps;

const Prices = (props: Props) => {
  let value = props.value;
  value = !value ? [null, null] : value;
  return <RangeFilter {...(props as any)} value={value} type={'number'} />;
};

export { Prices };
